import _ from "lodash";
import { CollectionAdapter } from "../../main/adapters/CollectionAdapter/CollectionAdapter";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";
import { mergeArray } from "../../utils/merge-array-by-proprerty";
import { MongoSelectorUtils } from "../../utils/mongoselector.utils";
import { NormalizeString } from "../../utils/normalize-string/NormalizeString";
const SeriesCollection = new Mongo.Collection("Series", {
    connection: null
});

export class Serie extends CollectionAdapter {
    HttpAdapter = new HttpAdapter();
    baseUrlDataTimeseries = `${publicSettings.aws.baseUrls.dataTimeseries}`;
    baseUrlIaAutoAssociatedAccounts =
        publicSettings.aws.iaAutoAssociatedAccounts;

    constructor({ PopulateManager } = {}) {
        super(SeriesCollection);
        this.PopulateManager = PopulateManager;
    }

    /**
     * Carrega series do plano de contas de DP e Fiscal
     * @param {Object} param0
     * @returns
     */
    async populateGroup({ companyIds, groupId, source, companies, isDre }) {
        let series = [];
        const companyIdsQuery = [...companyIds, groupId];
        if (isDre) {
            series = await this.getAccountsPlan({
                companyIds: companyIdsQuery,
                source,
                origin: "dre"
            });
        } else {
            series = await this.getAccountsPlan({
                companyIds: companyIdsQuery,
                source,
                origin: "editMode"
            });
        }

        series.forEach((serie) => {
            this.delete(serie._id);
            if (!serie.referenceId && companies.length) {
                const company = companies.find((c) => c._id == serie.companyId);
                if (company) serie.name = `${serie.name} - ${company.name}`;
            }
            this.create({ ...serie, groupId, sources: source });
        });
        return series.length || 0;
    }

    async setDependecies({ companyId, seriesIds, needAudit } = {}) {
        if (!companyId) return false;
        if (!seriesIds) return false;
        try {
            const response = await this.getByIds({
                companyIds: [].concat(companyId),
                serieIds: [].concat(seriesIds),
                options: {
                    includeChildren: true,
                    includeAudit: !!needAudit
                }
            });

            if (response.length) {
                response.forEach((serie) => {
                    this.PopulateManager.modify(
                        { collections: "series" },
                        {
                            $addToSet: { ids: serie._id }
                        }
                    );
                    const name_nd = NormalizeString.formatNameNdSearch(
                        serie.name
                    );
                    this.create({
                        ...serie,
                        companyId: "EMPRESA_NUCONT",
                        companyIdReference: serie.companyId,
                        name_nd
                    });
                });
            }

            return response;
        } catch (error) {
            console.error(error);
        }
    }

    async getByIds({ serieIds = [], companyIds, options = {} }) {
        const ids = _.uniq(serieIds.filter((id) => !!id).flat());
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/serie/get-by-ids`,
                {
                    ids,
                    companyIds: companyIds?.length
                        ? _.uniq([].concat(companyIds).filter((id) => !!id))
                        : [],
                    options
                }
            );
            return response.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    /**
     * @public
     * Busca series e popula de acordo com a pesquisa
     * @param {Object} companyId: string seriesIds: array
     */
    async getByCompanyDemand({
        companyId,
        seriesIds,
        needAudit,
        source,
        dependents = false,
        dependentsKpi = false,
        onlySeriesIds = false
    } = {}) {
        if (!companyId || !seriesIds.length) return false;

        const populateManagerSeries = this.PopulateManager.differenceBy(
            "series",
            seriesIds
        );

        try {
            if (populateManagerSeries.seriesIds.length || dependentsKpi) {
                if (dependentsKpi) {
                    await this.setDependecies({
                        companyId,
                        seriesIds,
                        needAudit
                    });
                } else {
                    let series = [];
                    series = await this.getByIds({
                        serieIds: seriesIds,
                        companyIds: [].concat(companyId)
                    });
                    if (dependents) {
                        const seriesDependentes = await this.getAccountsPlan({
                            companyIds: [].concat(companyId),
                            source,
                            origin: "accountsPlan"
                        });

                        series = mergeArray(series, seriesDependentes, "_id");
                    }

                    if (series.length) {
                        series.forEach((serie) => {
                            this.PopulateManager.modify(
                                { collections: "series" },
                                {
                                    $addToSet: { ids: serie._id }
                                }
                            );

                            serie.name_nd = NormalizeString.formatNameNdSearch(
                                serie.name
                            );

                            this.create({
                                ...serie,
                                companyId: "EMPRESA_NUCONT",
                                companyIdReference: serie.companyId
                            });
                        });
                    }
                    return series;
                }
            }
        } catch (error) {
            console.error(error);
        }
    }

    _injectDependecy({ series, serie } = {}) {
        const _getDependecy = (serie) => {
            const dependenciesIds = [];

            if (serie.compound && serie.genus == "derivative") {
                const seriesCompound = series.filter((s) =>
                    serie.compound.includes(s._id)
                );

                const ids = [];

                for (let i = 0; i < seriesCompound.length; i++) {
                    const serieCompound = _getDependecy(seriesCompound[i]);

                    ids.push(...serieCompound._id);
                }

                return ids;
            } else if (["analytic", "synthetic"].includes(serie.genus)) {
                return serie.associatedRaw;
            } else {
                return serie._id;
            }
        };

        return _getDependecy(serie);
    }

    async importDataDepartments({
        companyId = "",
        accounting = { _id: "", name: "" }
    }) {
        console.info("GERANDO OS DADOS DA EMPRESA ");
        const emptySeriesBySource = async (source) => {
            const response = await this.getByCompanyIdSources({
                companyId,
                sources: source
            });

            return response?.length ? true : false;
        };

        const [tax, personnel, fin] = await Promise.all([
            emptySeriesBySource("tax"),
            emptySeriesBySource("personnel"),
            emptySeriesBySource("fin")
        ]);
        if (tax && personnel && fin) return false;
        try {
            await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/departments/import`,
                {
                    companyId,
                    accounting
                }
            );
        } catch (error) {
            console.error(error);
        }
        return true;
    }

    serieGetCompound(visualizationCompound = []) {
        const seriesWithCompound = visualizationCompound.reduce(
            (visualizationResponse, currentVisualization) => {
                const seriesCompound = this.buildSerieCompound(
                    currentVisualization.serieIds,
                    currentVisualization.sources
                );
                visualizationResponse.push({
                    visualizationId: currentVisualization.visualizationId,
                    compound: seriesCompound,
                    sources: currentVisualization.sources
                });

                return visualizationResponse;
            },
            []
        );

        return seriesWithCompound;
    }

    digDeepDependencies(serie) {
        const dependencies = [];

        let serieCompound = _.get(serie, "compound.length") && serie.compound;
        while (serieCompound && serieCompound.length) {
            const deepSeries = this.findCollection(
                { _id: { $in: serieCompound } },
                { limit: Infinity },
                "array"
            );
            serieCompound = [];
            deepSeries.forEach((deepSerie) => {
                if (
                    !_.isEmpty(deepSerie.compound) &&
                    (deepSerie.exp || deepSerie.type === "dre")
                )
                    serieCompound = serieCompound.concat(deepSerie.compound);
                else if (_.get(deepSerie, "metadata.isPublicAccountsPlan"))
                    dependencies.push(deepSerie._id);
            });
        }

        return dependencies;
    }

    buildSerieCompound(seriesIds = [], sources) {
        let allSeries = [];

        const setSeries = (serieId) => {
            allSeries.push(serieId);
            const serie = this.get({ _id: serieId, sources });

            const compounds = _.get(serie, "[0].compound");

            if (compounds) {
                for (
                    let compoundIndex = 0;
                    compoundIndex < compounds.length;
                    compoundIndex++
                ) {
                    const serieCompound = compounds[compoundIndex];

                    if (serieCompound) setSeries(serieCompound);
                }
            }
        };

        for (let index = 0; index < seriesIds.length; index++) {
            const serieId = seriesIds[index];

            setSeries(serieId);
        }

        return _.uniq(allSeries);
    }

    _toArray = (term) => {
        if (Array.isArray(term)) return term;
        if (!term) return [];

        return term.split(/[\,,\;,\-]/);
    };

    _formatToInsert = (serie) => {
        if (!_.get(serie, "compound.length")) {
            delete serie.compound;
        }

        if (serie.sources) {
            serie.sources = Array.isArray(serie.sources)
                ? serie.sources
                : [serie.sources];
        }

        if (serie.classifierView) {
            serie.classifier = serie.classifierView.replace(/\D+/g, "");
            serie.classifier_nz = NormalizeString.classifierClean(
                serie.classifier
            );
        }

        if (_.get(serie, "info.kpisInfluence")) {
            serie.info.kpisInfluence = this._toArray(serie.info.kpisInfluence);
        }

        if (_.get(serie, "info.parameterizableAccounts")) {
            serie.info.parameterizableAccounts = this._toArray(
                serie.info.parameterizableAccounts
            );
        }

        if (_.get(serie, "info.notParameterizableAccounts")) {
            serie.info.notParameterizableAccounts = this._toArray(
                serie.info.notParameterizableAccounts
            );
        }

        if (serie.name) {
            serie.name_nd = NormalizeString.normalizeUpperCaseNd(
                serie.name.replace(/\s/g, "")
            );
        }

        return serie;
    };

    /**
     * @public
     *
     * @param {Object} serie
     */
    async insertOne(serie) {
        try {
            const newSerie = this._formatToInsert(serie);

            const { response } = await this.save(newSerie);

            newSerie.name_nd = NormalizeString.formatNameNdSearch(
                newSerie.name
            );

            this.create({
                _id: response,
                updatedAt: new Date().getTime(),
                ...newSerie
            });

            return true;
        } catch (error) {
            console.error(error);
            return null;
        }
    }

    async save(series, options = {}) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/serie/save`,
                { series: [].concat(series), options }
            );

            return response;
        } catch (error) {
            throw new Error("", error);
        }
    }

    async updateOne(_id, serie) {
        if (!_id) return false;

        if (!serie) return false;

        const newSerie = this._formatToInsert(serie);

        const response = await this.save({
            _id,
            ...newSerie
        });

        newSerie.name_nd = NormalizeString.formatNameNdSearch(newSerie.name);

        this.modify({ _id: { $eq: _id } }, { ...newSerie });

        return response;
    }

    async updateVisibleDRE(_id, visibleDRE) {
        if (!_id) return false;

        const response = await this.save([
            {
                _id,
                metadata: { visibleDRE }
            }
        ]);

        const res = this.modify(
            { _id: { $eq: _id } },
            { $set: { "metadata.visibleDRE": visibleDRE } }
        );

        return response;
    }

    async associate(companyId, series, userId, property = "associated") {
        await this.HttpAdapter.call(
            `${this.baseUrlDataTimeseries}/serie/associated`,
            {
                companyId,
                series: series.map((s) => ({
                    _id: s._id,
                    associated: s.associated.filter((a) => a)
                })),
                userId,
                property
            }
        );

        if (property === "associated") this._associateUpdateCollection(series);
        else this._parameterizationIdsUpdateCollection(series);
    }

    _parameterizationIdsUpdateCollection(series) {
        try {
            for (const serie of series) {
                this.modify(
                    { _id: { $eq: String(serie._id) } },
                    { $set: { parametrizeIds: serie.associated } }
                );
            }
        } catch (error) {
            console.error(error);
        }
    }

    _associateUpdateCollection(series) {
        const removeAssociated = (plan, series) => {
            const removeAssociated = series.filter(
                (s) =>
                    s.associated.includes(plan._id) &&
                    !plan.associated.includes(s._id)
            );

            for (let index = 0; index < removeAssociated.length; index++) {
                const serieUpdate = removeAssociated[index];
                const indexRemove = serieUpdate.associated.indexOf(plan._id);
                serieUpdate.associated.splice(indexRemove, 1);

                this.modify(
                    { _id: { $eq: serieUpdate._id } },
                    {
                        $set: {
                            associated: serieUpdate.associated
                        }
                    }
                );
            }
        };

        const addAssociated = (plan, series) => {
            const addAssociated = plan.associated.filter(
                (s) => !series.some((a) => a._id == s)
            );

            for (let index = 0; index < addAssociated.length; index++) {
                const serieUpdate = this.findOneCollection({
                    _id: { $eq: addAssociated[index] }
                });

                if (!serieUpdate.associated) serieUpdate.associated = [];
                serieUpdate.associated.push(plan._id);

                this.modify(
                    { _id: { $eq: serieUpdate._id } },
                    { $set: { associated: serieUpdate.associated } }
                );
            }
        };

        try {
            // atualizar minimongo
            series.forEach((plan) => {
                const seriesAssociated = this.findCollection(
                    { associated: { $eq: plan._id } },
                    {},
                    "array"
                );

                /* se a conta recebe parametrização, atribui a propriedade associatedRaw. senão, remove.*/
                if (plan.associated.length) {
                    this.modify(
                        { _id: { $eq: plan._id } },
                        { $set: { associatedRaw: plan.associated } }
                    );

                    removeAssociated(plan, seriesAssociated);
                    addAssociated(plan, seriesAssociated);
                } else {
                    this.modify(
                        { _id: { $eq: plan._id } },
                        { $unset: { associatedRaw: "" } }
                    );

                    removeAssociated(plan, seriesAssociated);
                }
            });
        } catch (error) {
            console.error(error);
        }
    }

    /**
     * @async
     * @public
     * @param {String} [companyId]
     * @param {String} [companyRefId] # Id de Empresa Referência
     * Função que invoca API para clonar Associated de Empresa Referência
     * para Empresa Nova, retorna lista de Series que sofreram Modificações
     * @return {Array}
     */
    async copyAssociated({ companyId, companyRefId } = {}) {
        return await this.HttpAdapter.call(
            `${this.baseUrlDataTimeseries}/serie/copy-associated`,
            {
                companyId,
                companyRefId
            }
        );
    }

    /**
     * Method that filters the series based on the parent classifier sent
     * @param {Object} selector
     * @param {Object} options includes an option $parent with the classifier
     */
    groupByClassifierBase(selector = {}, options = {}) {
        if (_.includes(["1", "2"], options.$parent)) {
            const reg = `^${options.$parent}`;

            Object.assign(selector, { classifier: { $regex: reg } });

            return this.findCollection(selector, options, "array");
        }

        const series = this.findCollection(selector, options, "array");

        return series.filter((serie) => {
            const classifier = serie.classifier
                ? parseInt(serie.classifier.charAt(0))
                : "";
            return classifier >= "3";
        });
    }

    /**
     * Hierarchize the series
     * @param {Array} series
     */
    hierarchize(series) {
        let maxLength = 0;

        series.forEach((serie) => {
            if (serie.classifier) {
                const length = serie.classifier.length;
                if (length > maxLength) maxLength = length;
                serie.level = length - 1;
            }
        });
        series.forEach((serie) => {
            if (serie.classifier) {
                const length = serie.classifier.length;
                serie.classifier += "0".repeat(maxLength - length);
            }
        });
        series = _.sortBy(series, (s) => s.classifier);

        series.forEach((serie) => {
            if (serie.classifier)
                serie.classifier = serie.classifier.replace(/[0]+$/, "");
        });

        return series;
    }

    /**
     * Method that gets the series with their associated series
     * @param {Object} query
     * @param {Object} options
     */
    getAssociated(series, options, companyId) {
        return series.map((serie) => {
            serie.associatedSeries = this.findCollection(
                {
                    companyId: { $eq: companyId },
                    associated: { $eq: serie._id }
                },
                options,
                "array"
            );

            return serie;
        });
    }

    /**
     * Sobrescreve this.Series.find
     * @param {Object} selector
     * @param {Object} options
     */
    get(selector = {}, options = {}, companyId) {
        let series;

        if (options.$parent)
            series = this.groupByClassifierBase(selector, options);
        else series = this.findCollection(selector, options, "array");

        if (options.$associated)
            series = this.getAssociated(series, options, companyId);

        if (options.$referenceAssociated) {
            series = series.map((serie) => {
                if (serie.referenceId) {
                    serie.associatedSeries = this.findCollection(
                        {
                            companyId: { $eq: companyId },
                            associated: { $in: [].concat(serie.referenceId) }
                        },
                        {},
                        "array"
                    );
                }

                return serie;
            });
        }

        if (options.hierarchize) return this.hierarchize(series);

        return series;
    }

    /**
     * @public
     * Get an array with all parent series ids children
     * @param {String} serieId
     * @param {Array} series
     * @param {Boolean} addMain
     * @returns {Array} series
     */
    getParent(serieId, series, addMain) {
        const seriesIds = [];
        const serie = series.find((s) => s._id == serieId);

        if (addMain && serieId) seriesIds.push(serie._id);

        const _searchId = (serie) => {
            if (_.get(serie, "compound"))
                serie.compound.forEach((c) => {
                    const nextSerie = series.find((s) => s._id == c);

                    if (nextSerie) {
                        seriesIds.push(c);
                        _searchId(nextSerie);
                    }
                });
        };

        _searchId(serie);

        return seriesIds;
    }

    /**
     * @public
     * Retorna plano de contas fatiado
     * @param {Object} companyId, classifierBase
     *
     * @return {Array}
     */
    getByClassifierBase({ companyId, classifierBase } = {}) {
        const response = this.get(
            { companyId, type: "raw", sources: "accounting" },
            {
                hierarchize: true,
                $parent: _.head(classifierBase),
                fields: {
                    associated: 1,
                    classifier: 1,
                    code: 1,
                    compound: 1,
                    genus: 1,
                    level: 1,
                    name: 1,
                    _id: 1
                }
            }
        );

        return response;
    }

    getSourceSelector(source) {
        let selectorSource = source;
        const taxSources = ["simplesNacional", "tax"];
        const personnelSources = ["personnel", "eSocial"];
        const sourceCobination = [...taxSources, ...personnelSources];

        if (sourceCobination.includes(source)) {
            if (taxSources.includes(source)) {
                selectorSource = taxSources;
            } else if (personnelSources.includes(source)) {
                selectorSource = personnelSources;
            }
        }

        return selectorSource;
    }

    async populate(selector, options = {}, fields) {
        const ignorePublic = _.get(options, "ignorePublic") || false;

        if (options.ignorePublic) delete options.ignorePublic;

        let response = {};

        if (selector.companyId === "EMPRESA_NUCONT") {
            response = await this.getByCompanyIdSources({
                companyId: "EMPRESA_NUCONT",
                sources: "accounting"
            });
        } else if (selector.accountingId) {
            response = await this.getAccountsPlan({
                companyIds: ["EMPRESA_NUCONT"],
                source: "accounting",
                origin: "customizationAccounting",
                options: {
                    includesCustomization: {
                        accountingId: selector.accountingId
                    }
                }
            });
        }

        if (ignorePublic) selector.public = { $ne: true };

        const accounting = _.get(selector, "$or[1].accountingId", false);

        if (accounting && accounting === "CONTABILIDADE_NUCONT") {
            selector.$or.splice(1, 1);
        }

        const selectorMiniMongo = MongoSelectorUtils.transformSimpleEqualToMongoEqual(
            selector
        );
        this.deleteMany(selectorMiniMongo);

        const hasResponse = _.get(response, "length");

        if (hasResponse) this.createMany(response, fields);

        // console.timeEnd(`${this.moduleName}.find.${JSON.stringify(selector)}`);
        return hasResponse ? true : false;
    }

    async saveDepartment({ series, source, companyId }) {
        await this.HttpAdapter.call(
            `${this.baseUrlDataTimeseries}/serie/update-department`,
            {
                series
            }
        );
        this.deleteMany({
            companyId: { $eq: companyId },
            sources: { $eq: source }
        });
        let origin = "editMode";
        if (source == "simplesNacional") origin = "accountsPlan";
        await this.populateDepartament({ companyId, source, origin });
    }

    async unsetParametrizationIds(_ids) {
        if (!_ids?.length) return false;

        const series = _ids.map((_id) => ({
            _id,
            parametrizeIds: []
        }));

        const response = await this.save(series);
        return response;
    }

    createMany(data = [], fields) {
        this._before();

        const total = data.length;

        if (!total) return false;

        for (let i = 0; i < total; i++) {
            let isPublic = !data[i].public ? false : true;
            const document = { ...data[i], ...fields, public: isPublic };
            if (document.name) {
                document.name_nd = NormalizeString.formatNameNdSearch(
                    document.name
                );
            }

            document.updatedAt = new Date(document.updatedAt).getTime();
            document.classifier_nz = parseFloat(document.classifier) || 0;

            this.create(document);
        }

        return true;
    }

    _getDependecies(rule) {
        const dependency = _.get(rule, "dependency")
            ? _.get(rule, "dependency")
            : _.get(rule, "series.dependency");

        const semiDependency = _.get(rule, "semiDependency")
            ? _.get(rule, "semiDependency")
            : _.get(rule, "series.semiDependency");

        return { dependency, semiDependency };
    }

    getDependenciesParameterized(rules, companyId) {
        let allDependencies = [];

        rules.forEach((rule) => {
            const { dependency, semiDependency } = this._getDependecies(rule);

            if (dependency)
                allDependencies = allDependencies.concat(dependency);
            if (semiDependency)
                allDependencies = allDependencies.concat(semiDependency);
        });

        const series = this.findCollection(
            {
                // companyId: companyId,
                _id: { $in: allDependencies }
            },
            { fields: { name: 1, associatedRaw: 1, _id: 1 } },
            "array"
        );

        return series;
    }

    _checkSerieAssociated(dependency, seriesParameterized) {
        return seriesParameterized.find((serie) => {
            if (dependency == serie._id && serie.associatedRaw) return true;
            else return false;
        });
    }

    serieToParameterize(rule, seriesParameterized) {
        const { dependency, semiDependency } = this._getDependecies(rule);

        if (!dependency && !semiDependency) return true;

        const dependencies = [];

        if (dependency) {
            for (let index = 0; index < dependency.length; index++) {
                const hasSerie = this._checkSerieAssociated(
                    dependency[index],
                    seriesParameterized
                );

                if (!hasSerie) dependencies.push(dependency[index]);
            }
        }
        if (semiDependency) {
            for (let index = 0; index < semiDependency.length; index++) {
                const hasSerie = this._checkSerieAssociated(
                    semiDependency[index],
                    seriesParameterized
                );

                if (!hasSerie) dependencies.push(semiDependency[index]);
            }
        }

        if (!dependencies.length) return false;
        const serie = this.findOneCollection({
            _id: { $eq: _.head(dependencies) }
        });

        return serie;
    }

    hasParameterization(rule, seriesParameterized) {
        const { dependency, semiDependency } = this._getDependecies(rule);

        if (!dependency && !semiDependency) return true;

        const hasDependencies = [];

        if (dependency) {
            for (let index = 0; index < dependency.length; index++) {
                const hasSerie = this._checkSerieAssociated(
                    dependency[index],
                    seriesParameterized
                );

                hasDependencies.push(hasSerie ? true : false);
            }

            return !hasDependencies.includes(false);
        }
        if (semiDependency) {
            for (let index = 0; index < semiDependency.length; index++) {
                const hasSerie = this._checkSerieAssociated(
                    semiDependency[index],
                    seriesParameterized
                );
                hasDependencies.push(hasSerie ? true : false);
            }

            return hasDependencies.includes(true);
        }
    }

    async populateAccountsPlans({ companyIds, source, origin, rewrite }) {
        if (origin === "goals") {
            const goalsSelector = {
                companyId: { $in: companyIds },
                sources: source,
                "metadata.origin": "goals"
            };
            if (source === "accounting") {
                goalsSelector.companyId = "EMPRESA_NUCONT";
            }
            const seriesPopulated = this.findCollection(
                goalsSelector,
                {},
                "array"
            );
            if (seriesPopulated?.length) return true;
        }
        const series = await this.getAccountsPlan({
            companyIds,
            source,
            origin
        });

        let needCompanyNucont = false;
        if (["accounting"].includes(source) && !rewrite) {
            needCompanyNucont = true;
        }
        series.forEach((serie) => {
            const input = {
                ...serie,

                sources: source
            };

            if (needCompanyNucont) {
                input.companyId = "EMPRESA_NUCONT";
            }
            this.delete(input._id);
            this.create(input);
        });

        return true;
    }

    async getByCompanyIdSources({ companyId, sources }) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/serie/get-by-companyid-sources`,
                {
                    companyId,
                    sources: [].concat(sources)
                }
            );

            return response?.list || [];
        } catch (error) {
            console.error("error", error);
        }
    }

    async populateByCompanyIdSources({ companyId, sources }) {
        try {
            const series = await this.getByCompanyIdSources({
                companyId,
                sources
            });
            series.forEach((serie) => {
                this.delete(serie._id);
                this.create({
                    ...serie,
                    type: serie.type || "raw",
                    companyId,
                    sources
                });
            });
            return true;
        } catch (error) {}
    }

    async populateAccountingGroup(companyIds, source) {
        const series = await this.getAccountsPlan({
            companyIds,
            source,
            origin: "raw"
        });

        series.forEach((serie) => {
            this.delete(serie._id);
            this.create({
                ...serie,
                type: serie.type || "raw",
                sources: source
            });
        });

        return true;
    }

    /**
     * @public
     * Retorna plano de contas
     * @param {Object} companyId: string, source: string
     * @return {Array}
     */
    async getAccountsPlan({ companyIds, source, origin, options }) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/serie/get-by-companyids-and-origin`,
                { companyIds: [].concat(companyIds), source, origin, options }
            );
            return response.list;
        } catch (error) {
            console.error("error", error);
            return [];
        }
    }

    /**
     * Carrega series do plano de contas de DP e Fiscal
     * @param {Object} param0
     * @returns
     */
    async populateDepartament({ companyId, source, origin }) {
        if (!origin) origin = "editMode";
        const series = await this.getAccountsPlan({
            companyIds: [companyId],
            source,
            origin: origin
        });

        series.forEach((serie) => {
            this.delete(serie._id);
            this.create({
                ...serie,
                companyId,
                sources: source
            });
        });
        if (series?.length) return series;
        return 0;
    }

    async populateVerticalReference({
        companyId,
        source,
        origin,
        verticalReference
    }) {
        if (!origin) origin = "editMode";
        const series = await this.getAccountsPlan({
            companyIds: [companyId],
            source,
            origin: origin
        });
        const verticalReferenceSerie = series.find((s) => {
            const name = NormalizeString.normalizeUpperCaseNd(s.name);
            const _verticalReference = NormalizeString.normalizeUpperCaseNd(
                verticalReference
            );
            return name === _verticalReference;
        });
        if (verticalReferenceSerie) {
            this.delete(verticalReferenceSerie._id);
            this.create({
                ...verticalReferenceSerie,
                companyId,
                sources: source
            });
        }
        return verticalReferenceSerie;
    }

    async dynamicExpressionsUpdate({ series, associated, seriesIds }) {
        const serie = series.find(
            (s) => s._id === associated._id || s.name === associated.name
        );
        if (!serie) return false;
        const exp = seriesIds.map((id) => `[${id}]`);
        await this.save([
            { _id: serie._id, compound: seriesIds, exp: exp.join(" + ") }
        ]);
    }

    /**
     * @public
     * Remove uma informação do backend
     * @param {Object} selector
     */
    async remove({ ids }) {
        let response = null;

        try {
            response = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/serie/remove-by-ids`,
                {
                    ids: [].concat(ids)
                }
            );
        } catch (error) {
            response = false;
        }

        this.deleteMany({ _id: { $in: [].concat(ids) } });

        return response;
    }

    async copySerieToAnotherSource({ companyId, sources }) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/serie/copy-to-another-source`,
                { companyId, sources }
            );

            if (_.get(response, "response")) return true;

            return false;
        } catch (error) {
            console.log("error", error);

            return false;
        }
    }

    async autoAssociatedAccounts({ companyId }) {
        try {
            const response = await this.HttpAdapter.call(
                this.baseUrlIaAutoAssociatedAccounts,
                { companyId }
            );
            return response;
        } catch (error) {
            console.log("erro autoAssociatedAccounts", error);
            return { ...error, error: true, status: "ERROR" };
        }
    }

    async hasAssociated({ companyId }) {
        // export type AssociationResult = {
        //     totalAssociations: number
        //     associations: AssociationType[]
        //     success: boolean
        //     audit: boolean
        //   }
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/serie/has-associated`,
                { companyId }
            );
            return response;
        } catch (error) {
            console.log("erro hasAssociated", error);
            return { ...error, error: true, status: "ERROR" };
        }
    }

    async removeAccountsPlan({ companyId, option } = {}) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/serie/remove-accounts-plan`,
                { companyId, option }
            );
            return { response, success: true };
        } catch (error) {
            console.log("erro removeAccountsPlan", error);
            return { ...error, error: true, success: false };
        }
    }
}

const fields = {
    companyId: 1,
    info: 1,
    name: 1,
    compound: 1,
    exp: 1,
    genus: 1,
    type: 1,
    unit: 1,
    polarity: 1,
    sources: 1,
    classifier: 1,
    classifierView: 1,
    metadata: 1,
    referenceId: 1,
    dependency: 1,
    highlight: 1,
    audit: 1,
    parametrizeIds: 1,
    associated: 1,
    level: 1,
    groupId: 1
};
